<div class="circle-overlay"><div class="theme-radio-off"></div></div>
<span class="leg">{{ selectionName }}<span class="theme-warning warning-color" *ngIf="hasWarning"></span> </span>
@switch (oddsState) {
    @case (pickOddsState.Locked) {
        <div class="lock-icon" [ngClass]="isEpcotEnabled ? 'theme-lock' : 'theme-locked-i'"></div>
    }
    @case (pickOddsState.Closed) {
        <div class="closed">{{ messages.closed }}</div>
    }
    @default {
        @if (signpostingData && signpostingData.text) {
            <ms-marketsubtype-logo
                class="betslip-digital-pick__line-last"
                [signpostingText]="signpostingData.text"
                [marketType]="signpostingData.marketType"
                [marketSubType]="signpostingData.marketSubType"
                [matchName]="pick.eventName.name"
                [sportId]="pick.sportId"
                [trackingLocation]="'betslip'"
                [tooltipAppendTo]="'bs-betslip-edit-state'"
                [tooltipBoundaries]="'bs-betslip-edit-state'"
                [tooltipPlacement]="'bottom-start'" />
        }
    }
}
@if (isRemoveButtonVisible) {
    <div class="remove-button theme-ex" (click)="removeSelection($event)"></div>
}
